<div class="page-body">
    <h1 data-aos="fade-down" data-aos-duration="800">Lighthouse: UofT Hacks</h1>
    <div class="info">
        <p><strong>Context</strong><br>36 hour hackathon</p>
        <p><strong>Outcomes</strong><br>Awarded a special mention in the health category </p>
        <p><strong>Materials/Tools</strong><br>Arduino Uno, web service, mobile phone</p>
    </div>

    <h2>Applying guided autonomy to decrease mobility restrictions </h2>
    <p>A common painful occurrence Dementia patients face is going out for a walk, then forgetting where they are and who they should contact.
        Lighthouse is an embedded door alert system and phone alert system that sends a message to a family member's phone when the patient walks out the door for a walk. After wandering more than 3km away from their home, the patient's phone will also text itself with a check-in message and the directions home.  </p>
    <p>Throughout our design and implementation process, we made sure that the elderly patient retains their autonomy. Our solution maximizes the freedom of the patient but also provides helpful guidance and reminders for the family members and the patient themselves.</p>
    <img class="process" src="assets/fun/lighthouse.png">
    <a class="next" routerLink="/csearch">Next work -></a>
</div>
